// Module
var code = "<html> <body style=\"font-family:Open+Sans;font-size:12px;padding-left:10px;padding-right:10px\"> <h2>Terms of Service</h2> <p>This page describes BMIC's terms of service.</p> </body> </html> ";
// Exports
export default code;